import { GzFormListWebComponent } from './component/GzFormListWebComponent';
import { WEB_COMPONENT_GZ_FORM_LIST } from '../../../webcomponents.constants';

export { GzFormListWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_FORM_LIST, GzFormListWebComponent);
